// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"93":"69ef06ec","395":"07fddfa9","746":"c96fd284","994":"61e4a956"}[chunkId] + ".chunk.js";
};